<div class="p-3" *ngIf="!viewdetails">
  <div class="row">
    <div class="col-12">
      <div class="card rounded mb-3">
        <!-- Header Section -->
        <div class="table-header">
          <div class="header-left">
            <div class="header-icon">
              <i class="pi pi-users"></i>
            </div>
            <div class="header-content">
              <h2 class="header-title">Committee Master</h2>
            </div>
          </div>
          <div class="header-actions">
              <p-button 
                label="Add New Committee" 
                icon="pi pi-plus" 
                (onClick)="addCommittee()"
                class="add-btn">
              </p-button>
          </div>
        </div>

        <!-- Filter Section -->
        <div class="filter-section">
          <div class="filter-left">
            <p-button 
              label="Clear Search" 
              icon="pi pi-times"
              severity="secondary"
              (click)="clearSearch()"
              *ngIf="searchProposalQuery"
              class="clear-filters-btn">
            </p-button>
          </div>
          <div class="filter-right">
            <span class="search-input p-input-icon-left">
              <i class="pi pi-search"></i>
              <input 
                type="text" 
                [(ngModel)]="searchProposalQuery" 
                (input)="searchProposals($event)" 
                placeholder="Search committees..." 
                class="search-field" />
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="dashboard-cards mb-4">
        <div class="dashboard-card shadow py-2">
          <div class="card-body">
            <div class="row g-4">
              <div class="col-12 col-md-6 col-lg-4" *ngFor="let com of committeeName">
                <div class="card scheme-card h-100 p-3 d-flex flex-column justify-content-between">
                  <div class="d-flex flex-wrap align-items-center justify-content-end mb-2">
                    <div class="d-flex gap-3">
                      <span pTooltip="Delete" tooltipPosition="top" (click)="deleteCommittee(com)" class="btn btn-light"
                        *ngIf="'/master/committee' | hasPermission: 'Delete'">
                        <i class="pi pi-trash delete-red"></i>
                      </span>
                      <span pTooltip="Edit" tooltipPosition="top" (click)="updateCommitte(com)" class="btn btn-light"
                        *ngIf="'/master/committee' | hasPermission: 'Delete'">
                        <i class="pi pi-pencil"></i>
                      </span>
                    </div>
                  </div>
                  <div class="ms-1 mt-2 mb-2">
                    <h5 class="text-xs fw-bold mb-1 h5-text">{{ com.name }}</h5>
                  </div>
                  <div class="flex-grow-1"></div>
                  <div class="mt-4">
                    <button class="btn btn-light w-100 border" (click)="ViewDetails(com)">
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="dashboard-cards mb-4">
        <div class="dashboard-card shadow py-2" *ngFor="let com of committeeName; let i = index"
          [ngStyle]="{ 'border-left': '6px solid ' + getColorCode(i) }">
          <!-- Committee Name -->
            <div class="card-text">
              <div class="text-xs" [ngStyle]="{ color: getColorCode(i)}">{{ com.name }}</div>
            </div>
            <div class="flex-grow-1"></div>
          <div class="card-body">
             <!-- Header buttons -->
            <div class="view-btn">
              <button class="btn" (click)="ViewDetails(com)">
                      View Details
              </button>
            </div>
            <div class="d-flex gap-2">
                <span pTooltip="Delete" tooltipPosition="top" (click)="deleteCommittee(com)"
                  class="btn btn-light action-icon" *ngIf="'/master/committee' | hasPermission: 'Delete'">
                  <i class="pi pi-trash"></i>
                </span>
                <span pTooltip="Edit" tooltipPosition="top" (click)="updateCommitte(com)"
                  class="btn btn-light action-icon" *ngIf="'/master/committee' | hasPermission: 'Edit'">
                  <i class="pi pi-pencil"></i>
                </span>
            </div>
           
            <!-- <div class="d-flex justify-content-end w-100 mt-3">
              
            </div> -->
            <!-- View Details button -->
            <!-- <button class="btn btn-outline-primary w-100 fw-semibold mt-3" (click)="ViewDetails(com)">
              View Details
            </button> -->
            

          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<ng-container *ngIf="viewdetails">
  <div class="p-3">
    <div class="row">
      <div class="col-12">
        <div class="card rounded mb-3">
          <form [formGroup]="assignmentForm" (ngSubmit)="onAssignmentSubmit()" class="p-3 mx-2">
            <h5 class="mt-3 mb-3"> <i class="pi pi-arrow-left me-2"
                (click)="viewdetails = false;"></i>{{selectedCommittee?.name}}</h5>
            <hr>
            <div class="d-flex row mb-3 mt-3 mb-3">
              <div class="d-flex col mb-3">
                <label>User <span class="text-danger">*</span></label>
                <p-dropdown [options]="userList" optionLabel="first_name" formControlName="user"
                  placeholder="Select User" [filter]="true" filterBy="first_name">
                  <ng-template let-scheme pTemplate="item">
                    <div class="list-group-item list-group-item-action">
                      {{ scheme.first_name }} - <small>{{ scheme.hrcdf_designation }}</small>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="d-flex col mb-3">
                <label>Role <span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="role" placeholder="Enter Role" maxlength="100"
                  class="h-40" />
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button type="submit" class="btn btn-primary" [disabled]="assignmentForm?.invalid">Add Member</button>
            </div>
          </form>
          <div class="p-3 mt-4">
            <app-data-table [columns]="memberCols" [data]="members" title="Committee Members"
              [isDeletable]="'/master/committee' | hasPermission: 'Delete'"
              [showAddButton]="'/master/committee' | hasPermission: 'Add'" [showActions]="canEditSetup"
              [isEditable]="'/master/committee' | hasPermission: 'Edit'" (deleteEventRow)="showDeletePopup($event)"
              (onLazyLoadData)="getCommitteeMembers($event)" [totalRecords]="totalRecords"
              (editEventRow)="updateCommittemeber($event)"></app-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-container>

<!-- -->



<p-dialog header="{{selectedCommittee?.id ? 'Update Committee' : 'Create Committee'}}" [(visible)]="showAddDialog"
  [modal]="true" [style]="{width: '500px'}" [closable]="true" [dismissableMask]="true" [maximizable]="true">

  <form [formGroup]="committeeForm" (ngSubmit)="onCommitteeSubmit()">
    <div class="mb-3 mt-3">
      <label class="form-label">Committee Name <span class="required-asterisk">*</span></label>
      <input type="text" class="form-control" formControlName="committeeName" maxlength="100">
      <div class="text-danger mt-1"
        *ngIf="committeeForm.get('committeeName')?.touched && committeeForm.get('committeeName')?.invalid">
        Name is required.
      </div>
    </div>
    <div class="d-flex justify-content-end btn-wrapper">
      <button type="submit" class="btn btn-primary" [disabled]="committeeForm.invalid || committeeForm.pristine ">
        Submit
      </button>
    </div>
  </form>
</p-dialog>

<p-dialog header="Update Member Details" [(visible)]="editMemberDialog" [modal]="true" [style]="{width: '500px'}"
  [closable]="true" [dismissableMask]="true" [maximizable]="true">

  <form [formGroup]="assignmentUpForm" (ngSubmit)="onAssignmentUpdateSubmit()" class="p-3 mx-2">
    <!-- <div class="d-flex row mb-3"> -->
    <div class="d-flex col mb-3">
      <label>User <span class="text-danger">*</span></label>
      <p-dropdown [options]="userList" optionLabel="first_name" formControlName="user" placeholder="Select User"
        [filter]="true" filterBy="first_name">
        <ng-template let-scheme pTemplate="item">
          <div class="list-group-item list-group-item-action">
            {{ scheme.first_name }} - <small>{{ scheme.hrcdf_designation }}</small>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="d-flex col mb-3">
      <label>Role <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="role" placeholder="Enter Role" class="h-40"
        maxlength="100" />
    </div>
    <!-- </div> -->
    <div class="d-flex justify-content-end mt-4">
      <button type="submit" class="btn btn-primary" [disabled]="assignmentUpForm?.invalid">Submit</button>
    </div>
  </form>
</p-dialog>

<p-dialog header="Delete Member" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
  [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete member ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteMember()"
      class="mt-2">
    </p-button>
  </div>
</p-dialog>